module.exports = __webpack_public_path__ + "media/巴赫平均律.eb892747.mp3";